export const isDemoMode = import.meta.env.VITE_UI_DEMO === "true";

export const demoUser = {
  id: "demo-user",
  email: "demo@mira.local",
  fullName: "TWIIN Demo",
  companyName: "Northstar Estates",
  avatarUrl: null,
  createdAt: new Date().toISOString(),
};

export const demoSessions = [
  {
    id: "demo-session-1",
    started_at: new Date(Date.now() - 1000 * 60 * 34).toISOString(),
    ended_at: new Date(Date.now() - 1000 * 60 * 28).toISOString(),
    duration_seconds: 386,
    status: "completed",
    transcript_messages: [
      {
        role: "user",
        content: "I am looking for a 3BHK near Whitefield under 1.8 crore.",
      },
      {
        role: "agent",
        content:
          "I found two matching inventory options with east-facing balconies and clubhouse access.",
      },
      {
        role: "user",
        content: "Can you send the brochure and arrange a weekend visit?",
      },
      {
        role: "agent",
        content:
          "Done. I logged your preference and prepared a Saturday site visit follow-up.",
      },
    ],
  },
  {
    id: "demo-session-2",
    started_at: new Date(Date.now() - 1000 * 60 * 60 * 26).toISOString(),
    ended_at: new Date(Date.now() - 1000 * 60 * 60 * 25.8).toISOString(),
    duration_seconds: 512,
    status: "completed",
    transcript_messages: [
      { role: "user", content: "Does the project have metro access?" },
      {
        role: "agent",
        content:
          "Yes. The closest station is planned within a short drive, and the sales deck highlights commute routes.",
      },
    ],
  },
];

export const demoKnowledgeEntries = [
  {
    id: "demo-knowledge-1",
    title: "Project Overview",
    content:
      "Premium real estate project context, pricing bands, amenities, and visit instructions.",
    file_path: null,
    file_type: "markdown",
    is_active: true,
  },
  {
    id: "demo-knowledge-2",
    title: "FAQ Sheet",
    content:
      "Common buyer questions about possession, RERA, payment schedules, and metro connectivity.",
    file_path: null,
    file_type: "txt",
    is_active: true,
  },
];

export const demoIntegrations = [
  { id: "demo-resend", provider: "resend", is_active: true },
  { id: "demo-calendly", provider: "calendly", is_active: false },
  { id: "demo-notion", provider: "notion", is_active: false },
];
